import styled from "@emotion/styled";
import { css } from "@emotion/react";

interface IndicatorProps {
  $type: "positive" | "negative";
}

export const StyledIndicator = styled.div<IndicatorProps>`
  font-weight: 700;
  ${(props) =>
    props.$type === "positive" &&
    css`
      color: green;
    `}

  ${(props) =>
    props.$type === "negative" &&
    css`
      color: red;
    `}
`;
